module.exports = __webpack_public_path__ + "public/img/3D1  GIF.f872269f.gif";